
const getButtonPos = (boothType) => {
  switch (boothType){
    case 1:
      return {
        vid: `
          top: 48.5%;
          left: 67.5%;
        `,
        image: `
          top: 50%;
          left: 40%;
        `,
        chat: `
          top: 67.5%;
          left: 67%;
        `,
        pdf: `
          top: 43%;
          left: 78.5%;
        `,
        info: `
          top: 6%;
          left: 73%;
        `,
        namecard: `
          top: 67%;
          left: 77%;
        `,
      }
    case 2:
      return {
        vid: `
          top: 50%;
          left: 31.5%;
        `,
        image: `
          top: 50%;
          left: 60%;
        `,
        chat: `
          top: 72.5%;
          left: 25%;
        `,
        pdf: `
          top: 43%;
          left: 79.5%;
        `,
        info: `
          top: 12.5%;
          left: 40%;
        `,
        namecard: `
          top: 60%;
          left: 15%;
        `,
      }
    case 3:
      return {
        vid: `
          top: 50.5%;
          left: 71.5%;
        `,
        image: `
          top: 45%;
          left: 35%;
        `,
        chat: `
          top: 67.5%;
          left: 82%;
        `,
        pdf: `
          top: 46%;
          left: 61%;
        `,
        info: `
          top: 8.5%;
          left: 64%;
        `,
        namecard: `
          top: 78%;
          left: 67%;
        `,
      }
    case 4:
      return {
        vid: `
          top: 46%;
          left: 69%;
        `,
        image: `
          top: 50%;
          left: 35%;
        `,
        chat: `
          top: 71.5%;
          left: 66%;
        `,
        pdf: `
          top: 69%;
          left: 51%;
        `,
        info: `
          top: 18%;
          left: 63%;
        `,
        namecard: `
          top: 82.5%;
          left: 72.5%;
        `,
        zoom: `
          top: 82.5%;
          left: 72.5%;
        `,
      }
    case 5:
      return {
        vid: `
          top: 48%;
          left: 65.5%;
        `,
        image: `
          top: 50%;
          left: 32%;
        `,
        chat: `
          top: 71.5%;
          left: 66%;
        `,
        pdf: `
          top: 65.5%;
          left: 48.5%;
        `,
        info: `
          top: 18%;
          left: 43%;
        `,
        namecard: `
          top: 78.5%;
          left: 73%;
        `,
      }
    default:
      return {}
  }
}
export { getButtonPos };